import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import firebase from "gatsby-plugin-firebase"
import AuthLayout from "../../components/AuthLayout"
import { numberWithCommas } from "../../utils/helper"
import "./signin.less"
import { Tabs, Form, Input, Checkbox, Button, notification } from "antd"

const { TabPane } = Tabs
let courseUsers = []

const SigninPage = ({ location }) => {
  const [formSignup] = Form.useForm()
  const [submitLogin, setSubmitLogin] = useState(false)
  const [submitSignup, setSubmitSignup] = useState(false)
  let storageUser = null
  const isBrowser = typeof window !== "undefined"
  if (isBrowser) {
    storageUser = JSON.parse(localStorage.getItem("firebaseLMSUser"))
  }
  const booking = location?.state?.booking
  const courseId = location?.state?.courseId
  const courseName = location?.state?.courseName

  useEffect(() => {
    if (isBrowser && firebase) {
      if (storageUser || firebase.auth().currentUser) {
        navigate("/backend/dashboard")
        return null
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firebase])

  const onFinishLogin = async values => {
    if (isBrowser && firebase) {
      setSubmitLogin(true)
      const { email_login, password_login, remember_login } = values
      if (remember_login) {
        const persist = await firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => {
            return true
          })
          .catch(error => {
            setSubmitLogin(false)
            console.log("error ", error)
            notification["error"]({
              message: error.code || error.name || error.status,
              description: error.error_description || error.message,
              duration: 0,
            })
            return false
          })

        if (persist) {
          firebase
            .auth()
            .signInWithEmailAndPassword(email_login, password_login)
            .then(() => {
              navigate("/backend/dashboard")
            })
            .catch(error => {
              setSubmitLogin(false)
              console.log("error ", error)
              if (error.code === "auth/user-not-found") {
                notification["error"]({
                  message: error.code,
                  description:
                    "ไม่มีอีเมลนี้อยู่นระบบ คุณอาจจะกรอกผิดหรือยังไม่ได้ลงทะเบียนไว้",
                  duration: 0,
                })
              } else if (error.code === "auth/wrong-password") {
                notification["error"]({
                  message: error.code,
                  description: "รหัสผ่านของคุณไม่ถูกต้อง",
                  duration: 0,
                })
              } else {
                notification["error"]({
                  message: error.code || error.name || error.status,
                  description: error.error_description || error.message,
                  duration: 0,
                })
              }
            })
        }
      } else {
        firebase
          .auth()
          .signInWithEmailAndPassword(email_login, password_login)
          .then(() => {
            navigate("/backend/dashboard")
          })
          .catch(error => {
            setSubmitLogin(false)
            console.log("error ", error)
            if (error.code === "auth/user-not-found") {
              notification["error"]({
                message: error.code,
                description:
                  "ไม่มีอีเมลนี้อยู่นระบบ คุณอาจจะกรอกผิดหรือยังไม่ได้ลงทะเบียนไว้",
                duration: 0,
              })
            } else if (error.code === "auth/wrong-password") {
              notification["error"]({
                message: error.code,
                description: "รหัสผ่านของคุณไม่ถูกต้อง",
                duration: 0,
              })
            } else {
              notification["error"]({
                message: error.code || error.name || error.status,
                description: error.error_description || error.message,
                duration: 0,
              })
            }
          })
      }
    } else {
      notification["error"]({
        message: "Error",
        description: "Undefined window!",
        duration: 0,
      })
    }
  }
  const onFinishSignup = async values => {
    if (isBrowser && firebase) {
      setSubmitSignup(true)
      const {
        email_signup,
        password_signup,
        firstname_signup,
        lastname_signup,
        line_signup,
      } = values
      const createUser = await firebase
        .auth()
        .createUserWithEmailAndPassword(email_signup, password_signup)
        .then(credential => {
          return credential.user
        })
        .catch(error => {
          setSubmitSignup(false)
          console.log("error ", error)
          notification["error"]({
            message: error.code || error.name || error.status,
            description: error.error_description || error.message,
            duration: 0,
          })
          return null
        })
      if (createUser) {
        const userId = createUser.uid
        const data = {
          firstName: firstname_signup,
          lastName: lastname_signup,
          lineId: line_signup,
          email: email_signup,
          creationTime: createUser.metadata.creationTime,
          disabled: false,
          admin: false,
        }
        const createUsers = await firebase
          .firestore()
          .collection("users")
          .doc(userId)
          .set(data)
          .then(() => {
            const storageUser = {
              uid: userId,
              email: email_signup,
              firstName: firstname_signup,
              lastName: lastname_signup,
            }
            localStorage.setItem("firebaseLMSUser", JSON.stringify(storageUser))
            return true
          })
          .catch(error => {
            setSubmitSignup(false)
            console.log("error firestore collection set ", error)
            notification["error"]({
              message: error.code || error.name || error.status,
              description: error.error_description || error.message,
              duration: 0,
            })
            return false
          })
        if (createUsers) {
          if (booking) {
            // Query
            const objRef = firebase
              .firestore()
              .collection("courses")
              .doc(courseId)
            if (objRef) {
              const doc = await objRef.get()
              const docData = doc.data()
              if (docData && docData.users) {
                const people = docData.users.length
                courseUsers = docData.users
                let normalPrice = 0
                if (people <= 9) {
                  normalPrice = 1200
                } else if (people >= 10 && people <= 49) {
                  normalPrice = 2800
                } else if (people >= 50 && people <= 99) {
                  normalPrice = 3900
                } else {
                  normalPrice = 5800
                }
                const total = numberWithCommas(normalPrice)
                // Process
                const numBook = parseInt(people) + 1
                let optionText = ""
                if (people <= 9) {
                  optionText = "สำหรับผู้จอง 10 คนแรก - เข้าเรียนซ้ำได้ 3 เดือน"
                } else if (people >= 10 && people <= 49) {
                  optionText =
                    "สำหรับผู้จอง คนที่ 11-50 - เข้าเรียนซ้ำได้ 3 เดือน"
                } else if (people >= 50 && people <= 99) {
                  optionText =
                    "สำหรับผู้จอง คนที่ 51-100 - เข้าเรียนซ้ำได้ 3 เดือน"
                } else {
                  optionText =
                    "สำหรับผู้จอง คนที่ 101 ขึ้นไป - เข้าเรียนซ้ำได้ 3 เดือน"
                }
                const datas = {
                  id: userId,
                  num: numBook,
                  price: numberWithCommas(normalPrice) + " บาท",
                  option: optionText,
                  total: total + " บาท",
                }
                courseUsers.push(datas)
                const courses = {
                  name: courseName,
                  users: courseUsers,
                }
                // Courses
                const addCourse = await firebase
                  .firestore()
                  .collection("courses")
                  .doc(courseId)
                  .set(courses)
                  .then(() => {
                    return true
                  })
                  .catch(error => {
                    setSubmitSignup(false)
                    console.log("error firestore collection set ", error)
                    notification["error"]({
                      message: error.name || error.status,
                      description: error.error_description || error.message,
                      duration: 0,
                    })
                    return false
                  })
                // Booking
                if (addCourse) {
                  const bookingData = {
                    uid: userId,
                    courseId: courseId,
                    courseName: courseName,
                    num: numBook,
                    total: total + " บาท",
                    pay: false,
                    creationTime: firebase.firestore.Timestamp.now(),
                  }
                  await firebase
                    .firestore()
                    .collection("booking")
                    .add(bookingData)
                    .then(() => {
                      navigate("/thank-you", {
                        state: {
                          courseId: courseId,
                        },
                      })
                      notification["success"]({
                        message: "ยินดีด้วยครับ",
                        description: "คุณได้ลงทะเบียนและจองคอร์สสำเร็จแล้ว",
                        duration: 0,
                      })
                    })
                    .catch(error => {
                      setSubmitSignup(false)
                      console.log("error firestore collection set ", error)
                      notification["error"]({
                        message: error.name || error.status,
                        description: error.error_description || error.message,
                        duration: 0,
                      })
                    })
                }
              } else {
                notification["error"]({
                  message: "Error",
                  description: "Booking error!, plese try again later...",
                  duration: 0,
                })
              }
            } else {
              notification["error"]({
                message: "Error",
                description: "Booking error!, plese try again later...",
                duration: 0,
              })
            }
          } else {
            notification["success"]({
              message: "ยินดีด้วยครับ",
              description: "คุณได้ลงทะเบียนสำเร็จแล้ว",
              duration: 0,
            })
            navigate("/")
          }
        }
      }
    } else {
      notification["error"]({
        message: "Error",
        description: "Undefined window!",
        duration: 0,
      })
    }
  }

  if (isBrowser && firebase && firebase.auth().currentUser) {
    return null
  }

  return (
    <AuthLayout>
      <div className="pageContainer">
        <Tabs defaultActiveKey={booking ? "2" : "1"} centered>
          <TabPane tab={"เข้าสู่ระบบ"} key="1">
            <Form layout="vertical" onFinish={onFinishLogin}>
              <Form.Item
                label="อีเมล"
                name="email_login"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                  {
                    type: "email",
                    message: "ที่อยู่อีเมลไม่ถูกต้อง!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="รหัสผ่าน"
                name="password_login"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item name="remember_login" valuePropName="checked">
                <Checkbox>บันทึกการใช้งาน</Checkbox>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  loading={submitLogin}
                  disabled={submitLogin}
                >
                  เข้าสู่ระบบ
                </Button>
              </Form.Item>
              <Form.Item className="halfCol">
                <div />
                <Link to="/auth/forgot-password">จำรหัสผ่านไม่ได้?</Link>
              </Form.Item>
            </Form>
          </TabPane>
          <TabPane tab={"ลงทะเบียน"} key="2">
            <Form form={formSignup} layout="vertical" onFinish={onFinishSignup}>
              <Form.Item
                label="ชื่อ"
                name="firstname_signup"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="นามสกุล"
                name="lastname_signup"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="ไลน์"
                name="line_signup"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="อีเมล"
                name="email_signup"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                  {
                    type: "email",
                    message: "ที่อยู่อีเมลไม่ถูกต้อง!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="รหัสผ่าน"
                name="password_signup"
                rules={[
                  {
                    required: true,
                    message: "จำเป็นต้องกรอกข้อมูล!",
                  },
                  {
                    min: 6,
                    message: "ขั้นต่ำ 6 ตัวอักษร!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item shouldUpdate>
                {() => (
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={submitSignup}
                    disabled={
                      submitSignup ||
                      !formSignup.isFieldsTouched(true) ||
                      !!formSignup
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length
                    }
                  >
                    ลงทะเบียน
                  </Button>
                )}
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>
      </div>
    </AuthLayout>
  )
}

export default SigninPage
